import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { withStyles } from '@material-ui/core/styles';
import ListNameAutocomplete from './listnameautocomplete';
import { withStylesPropTypes, formatDate } from '../../helper/misc';
import { selectListsLoading, selectListsError, selectListIds } from '../../app/listSelectors';
import ListPayloadTable from './listpayloadtable';
import Loading from '../common/loading';
import Error from '../common/error';

const useStyles = ((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  searchBar: {
    flexGrow: 0,
    minHeight: theme.spacing(4),
    flexDirection: 'row',
    display: 'flex',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    alignItems: 'center',
    '&>div': {
      flexGrow: 1,
      flexBasis: 0,
      overflow: 'hidden',
    },
    '&>div:nth-child(2)': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '&>div:nth-child(3)': {
      flexBasis: theme.spacing(2),
    },
  },
  table: {
    flexGrow: 1,
  },
  sortOption: {
    color: theme.palette.primary.main,
    '&>.MuiButtonBase-root': {
      padding: 0,
    },
  },
}));


function NavigationByPayloadALIMatching({
  classes,
  listsLoading,
  listsError,
  anyListsLoaded,
  extraHeaderComponent,
  lockRecordType,
}) {
  const [searchByName, setSearchByName] = useState('');

  return (
    <div className={classes.root}>
      {
        listsError && (<div className={classes.searchBar}><Error message={listsError.message} /></div>)
      }
      {
        listsLoading && (<Loading progress={listsLoading.progress} />)
      }
      {
        anyListsLoaded && !listsError && (
        <>
          <div className={classes.searchBar}>
            <div>LIST SELECTION</div>
            <div>
              <ListNameAutocomplete
                value={searchByName}
                onChange={(value) => setSearchByName(value ? value.shortName : null)}
              />
            </div>
            <div>{extraHeaderComponent}</div>
          </div>
          <div className={classes.table}>
            <ListPayloadTable
              payloadsSelectable={false}
              listsSelectable
              nameFilter={searchByName}
              lockRecordType={lockRecordType}
              payloadsFilter={(p) => !!p.payloadId}
              showEmptyPayloads
              columns={[
                {
                  title: 'Most Recent Payload',
                  dataKey: 'lastPayload',
                  type: 'date',
                  dataGetter: ({ rowData }) => formatDate(rowData.lastPayload),
                },
                {
                  title: 'Last Edit',
                  dataKey: 'lastAliMergeAt',
                  type: 'date',
                  dataGetter: ({ rowData }) => formatDate(rowData.lastAliMergeAt),
                },
                {
                  title: 'Available Matches Left',
                  dataKey: 'aliMatchesLeft',
                  type: 'number',
                },
              ]}
            />
          </div>
        </>
        )
      }
    </div>
  );
}

NavigationByPayloadALIMatching.defaultProps = {
  extraHeaderComponent: null,
  lockRecordType: null,
};

NavigationByPayloadALIMatching.propTypes = {
  ...withStylesPropTypes,
  extraHeaderComponent: PropTypes.node,
  lockRecordType: PropTypes.string,
};

const selectAnyListsLoaded = createSelector(
  [selectListIds],
  (listIds) => !!listIds.length,
);

const mapStateToProps = (state, props) => ({
  listsLoading: selectListsLoading(state, props),
  listsError: selectListsError(state, props),
  anyListsLoaded: selectAnyListsLoaded(state, props),
});

export default connect(mapStateToProps, null)(withStyles(useStyles)(NavigationByPayloadALIMatching));
